import { useSupabaseLoader } from "../../../../../server/supabase/hooks";
import type { UseSupabaseLoaderState } from "../../../../../server/supabase/hooks/types";
import type { UseMomentProperties } from "../../../../moment-card/types";
import { SupabaseMomentCardMomentService } from "../../../../moment/server/supabase-moment-service";

export const useEmailCommunicationMoments = (): UseSupabaseLoaderState<UseMomentProperties[]> & {
  reload: () => void;
} => {
  return useSupabaseLoader(async ({ supabase, account_id }) => {
    const { data, error } = await new SupabaseMomentCardMomentService(supabase).getAllMoments(
      account_id,
      {
        order: [{ column: "title" }],
        filter: [
          { key: "status", operator: "neq", value: "draft" },
          {
            key: "channel",
            operator: "in",
            value: '("work_email","personal_email")',
          },
        ],
      },
    );

    if (error) throw new Error(error.message);
    return data ?? [];
  }, []);
};
